const hasPhones = (phones) => {
  const format = phone =>
    `(${phone.phoneNumber.slice(0, 3)}) ${phone.phoneNumber.slice(
      3,
      6,
    )}-${phone.phoneNumber.slice(-4)}`;
  return {
    getDefaultPhone() {
      const index = phones.findIndex(phone => phone.isDefault);
      return index === -1 ? '' : format(phones[index]);
    },
    getFormattedPhones() {
      return phones.map((phone) => {
        const formatted = {
          label: phone.label,
          phoneNumber: format(phone),
        };
        if (phone.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
  };
};

export default hasPhones;
